import t from "../../../helpers/t";
import React from "react";
import SortNav from "../../../components/SortNav";
import PricetariffItem from './PricetariffItem';
import AddPricetariffButton from "./AddPricetariffButton";

const ProductsPricetariffs = (props) => {
    let tabs =[{
        name: t('id',null,'capital'),
        mediumWidth: 1,
        smallWidth: 4,
        title: t('id',null,'capital'),
        canSort: false
    }, {
        name: t('name',null,'capital'),
        mediumWidth: 4,
        smallWidth: 8,
        title: t('name',null,'capital'),
        canSort: false
    },{
        name: t('description',null,'capital'),
        mediumWidth: 7,
        smallWidth: 12,
        title: t('description',null,'capital'),
        canSort: false
    }];
    return(
        <>     <div style={{float:"left"}} className="row small-12">
                <div className="inb-form-group column medium-8 small-12">
                    <label className="inb-form__controlLabel">{t('pricetariffs',null,'capital')}</label>
                </div>
          {/*  <div className="inb-form-group column medium-12 small-12">
                <AddPricetariffButton
                    product={props.product}
                />
            </div>*/}

        </div>
            <div className="columns medium-12 small-12"> <SortNav
                    tabs={tabs}
                    inline={true}
                />
                {typeof props.pricetariffs !== "undefined" && props.pricetariffs.length >= 1 && [...props.pricetariffs].map( (val,key) => {
                    return(
                        <>
                        <PricetariffItem
                            pricetariff={val}
                            product={props.product}
                            dispatch={props.dispatch}
                         />
                         </>
                    );

                })}
            </div>
</>
    );
};

export default ProductsPricetariffs;